export default __webpack_public_path__ + "images/NZ.12b248e.png";